export default __webpack_public_path__ + "static/media/piratenxhumanisten_quadrat_dunkel.6da8a348.svg";